<template>
  <!-- <Card archive-card :class="[item.type, item.category, cardType]">
    <div archive-card-content @click="$emit('click',item)">
      <div archive-card-img v-if="item.type === 'img'" :style="{backgroundImage: `url('${item.thumbnailPath}')`}">
        <div class="date">{{ item.date }}</div>
      </div>
      <div class="content-inner" :class="{'has-tag': item.tags}">
        <div class="date" v-if="item.type === 'text' || item.type === 'notice' || item.type === 'faq'">{{ item.date }}</div>
        <p class="title" v-html="trim(item.title)"></p>
        <p class="txt" :class="item.type" v-if="(cardType === 'main-h' || item.type !== 'img') && item.content" v-html="getSummary(item.content)"></p>
        <p class="name" :class="item.type" v-if="item.modr" v-html="getSummary(item.modr)"></p>
        <p class="duration" v-if="item.duration && cardType !== 'main-h' && cardType !== 'main-w'"><Icon name="clock"/><s>{{ item.duration }}</s></p>
      </div>
      <div class="tags" v-if="item.tags">
        <a @click="$emit('tagClick',tag)" v-for="tag in item.tags" :key="tag"><s>{{tag}}</s></a>
      </div>
      <div class="category">
        <s>{{ item.category.toUpperCase() }}</s>
        <s>자세히 보기</s>
        <Icon name="arrow-right-white"/>
      </div>
    </div>
  </Card> -->
  <Card archive-card :class="[item.type, item.category, cardType]">
    <div archive-card-content @click="$emit('click', item)">
      <div archive-card-img v-if="item.tnUrl" :style="{backgroundImage: `url('${item.tnUrl}')`}"></div>
      <div class="content-inner" :class="{'has-tag': item.keywordList}">
        <p class="title" v-html="item.title"></p>
        <p class="txt" v-if="(!item.tnUrl)" v-html="item.content"></p>
      </div>
      <div class="tags" v-if="item.keywordList">
        <a @click="$emit('tagClick', tag)" v-for="tag in item.keywordList" :key="tag"><s>{{tag}}</s></a>
      </div>
      <div class="category">
        <s>자세히 보기</s>
        <Icon name="arrow-right-white"/>
      </div>
    </div>
  </Card>
</template>

<script>
import _ from 'lodash';
import Card from '@/views/components/Card';
import Icon from '@/views/components/Icon';

export default {
  name: 'ArchiveCard',
  components: { Icon, Card },
  props: {
    item: Object,
    cardType: { default: '' },
  },
  data() {
    return {
      status: '',
    };
  },
  methods: {
    getSummary(content) {
      if (!content) return '';
      return _.unescape(content).replace(/(<([^>]+)>)/ig, ' ');
    }
  },
  mounted() {
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

[archive-card] {
  [archive-card-content] { .-box; .rel; .bgc(#2c3036);
    [archive-card-img] { .pt(60%); .rel; .bgc(#ccc); .cover; .bg-c; .no-repeat; }
    .date { .fs(18); .calibre; .medium; }
    .content-inner { .h(72); .p(20,20,54); color: #fff;
      .title { .fs(24, 36, -1); .extra-bold; .max-h(72); .ellipsis(2); .keep-all;
        .en & { .fs(28,32,0); .medium; .max-h(96); .ellipsis(3);  }
      }
      .date + .title { .mt(15); }
      .txt { .fs(16, 1.75); .ls(-0.5); .mt(10); .semi-bold; color: #e0e0e0; .ellipsis(4); .max-h(112);
        .en & { .fs(16,22,0); .regular; color: #bdbdbd; }
        &.text { .ellipsis(6); .max-h(168); }
        &.faq { .hide; }
      }
      .duration { .fs(16); color: #bdbdbd; .mt(8); .calibre;
        s { .cal-m; .vam; }
        [icon] { .mr(4); }
      }
      &.has-tag { .pb(105); }
    }
    .tags { .abs; .lb(0, 63); .p(0, 20);
      a { .fs(13); .lh(18); .p(2, 5); .h(22); .-box; .-a(#757575); .br(2); .calibre; color: #757575; .gap-hr(6);
        s { .cal-m; }
        .no-touch &:hover, &.on { color: #0777ff; .-a(#0777ff) }
      }
    }
    .category { .abs; .lb; .p(14,20); .wf; .-box;
      s { .fs(16, 23, 0); .medium; .cal-m; }
      [icon] { .abs; .rb(20,14); 
        &.icon-arrow-right-white { .wh(24); }
      }
    }
    .tags + .category { .-t(#373d42); }
  }

  &.main-h {
    [archive-card-content] {
      .content-inner {
        .txt { .hide; }
      }
    }
  }

  &.main-n {
    [archive-card-content] {
      .content-inner {
        .title { .fs(20,32,-1); .max-h(64);
          .en & { .fs(28,32,0); .max-h(96); }
        }
        .txt {
          &.text { .ellipsis(4); .max-h(112);
          }
        }
      }
    }
    &.faq {
      .content-inner { .min-h(139);
        .title { .ellipsis(3); .max-h(96); }
      }
    }
    &.img {
      .content-inner {
        .title { .ellipsis(2); .max-h(64); }
      }
    }
  }

  &.img {
    .date { .abs; .lt(20,20); color: #fff; }
  }

  &.article-n {
    .content-inner {
      .title { .fs(20, 32, -1); .max-h(64); }
    }
    &.faq {
      .content-inner { .min-h(139);
        .title { .ellipsis(3); .max-h(96); }
      }
    }
  }

  &.notice {
    .content-inner {
      .title { .ellipsis(3); .max-h(108); }
    }
  }


}

@media (min-width: @screen-md-min) {
  [archive-card] {
    [archive-card-content] {
      .content-inner {
        .txt { .mt(20);
          &.text { .ellipsis(4);
            .en & { .ellipsis(7); .max-h(154); }
          }
        }
      }
    }
    &.more { .mt(60); }
    &.article-n {
      &.img {
        .content-inner { .-box; .h(150);
          .title {
            .en & { .max-h(64); .ellipsis(2);  }
          }
        }
      }
      &.text {
        [archive-card-content] { .pt(60%); .h(150); box-sizing: content-box;
          .content-inner { .mt(-60%); }
        }
      }
    }
    &.article-t, &.main-h, &.main-w {
      &.img {
        .content-inner { .-box; .h(226); }
      }
      &.text {
        [archive-card-content] { .pt(60%); .h(226); box-sizing: content-box;
          .content-inner { .mt(-60%); }
        }
      }
    }
    &.main-w {
      [archive-card-content] {
      }
    }

    &.main-n {
      [archive-card-content] { .h(335);
        .content-inner {
          .txt {
            &.text {
              .en & { .ellipsis(5); .max-h(112); }
            }
          }
        }
      }
      &.faq {
        [archive-card-content] { .h(213); }
      }
    }
  }
}

@media (min-width: @screen-lg-min) {
  [archive-card] {
    [archive-card-content] {
      .content-inner {
        .title { .fs(24, 36, -1); }
        .txt { .bold;
          &.text { .ellipsis(5); }
        }
      }
    }
    &.article-n {
      &.img {
        .content-inner { }
      }
      &.text {
        [archive-card-content] {
          .content-inner {
            .txt {
              &.text { .ellipsis(4); .max-h(112); }
            }
          }
        }
      }
      &.faq {
        .content-inner { .min-h(159);
          .title { .max-h(108); }
        }
      }
    }

    &.main-n {
      &.faq {
        [archive-card-content] { .h(233);
          .content-inner { .min-h(159);
            .title { .max-h(108); }
          }
        }
      }
    }

    &.article-t {
      &.img {
        .content-inner { }
      }
      &.text {
        [archive-card-content] {
          .content-inner {
            .txt {
              &.text { .ellipsis(5); .max-h(138); }
            }
          }
        }
      }
    }

    &.more { .mt(40); }
  }
}


@media (min-width: @screen-xl-min) {
  [archive-card] {
    [archive-card-content] {
      .content-inner { .p(30, 25, 70); }
      .tags { .b(76); }
      .category {.p(18,25);
        [icon] { .rt(20,18); }
      }
    }

    &.img {
      .date { .lt(25,30); }
      .content-inner { .pt(20);
        .title + .txt { .ellipsis(3); }
      }
    }

    &.article-n {
      &.img {
        .content-inner { }
      }
      &.text {
        [archive-card-content] {
          .content-inner {
            .txt {
              &.text { .ellipsis(6); .max-h(168); }
            }
          }
        }
      }
      &.faq {
        .content-inner { .min-h(166);
        }
      }
    }

    &.article-t {
      &.img {
        .content-inner { }
      }
      &.text {
        [archive-card-content] {
          .content-inner {
            .txt {
              &.text { .ellipsis(6); .max-h(168); }
            }
          }
        }
      }
    }

    &.main-n {
      &.faq {
        .content-inner { .min-h(166);
        }
      }
    }

    &.more { .mt(40); }
  }
}

@media (min-width: @screen-xxl-min) {
  [archive-card] {
    &.main-h {
      [archive-card-content] { .h(780); }
      [archive-card-img] { .pt(402); }
      .content-inner {
        .title { .fs(28,40,-1); .pre-line; .ellipsis(2); .max-h(80); }
        .title + .txt { .ellipsis(4); .h(112); }
      }
    }
    &.main-w-dep.img {
      [archive-card-img]{ .wh(300,240); .abs; .pt(0); z-index: 1;}
      .content-inner {.pl(320); .h(240); .-box;
        .title{ .ellipsis(2); .max-h(80); .pre-line;}
      }
      .tags{.pl(320);}
      .category{.pl(320);}
    }
    &.main-w-dep.text {
      [archive-card-content] { .p(0); .h;
        .content-inner { .h(240); .-box; .pt(20); .mt(0);
          .title { .ellipsis(1); .h(36); .mt(10); }
          .txt { .ellipsis(2); .max-h(56); }
        }
        .tags { .rt(0, 20); }
      }
    }
    &.main-n {
      [archive-card-content] { .h(400);
        .content-inner {
          .title { .fs(24,36,-1); .max-h(72); }
          .txt { .mt(20);
            &.text { .ellipsis(5); .max-h(140); }
          }
        }
      }
      &.faq {
        [archive-card-content] { .h(240); }
      }
    }

  }
}

</style>
